/**
 * Query-key roots of the booking flow. Exported so apps that persist their query cache keep these out of storage
 * (CIN-15436): seat locks, prices and a paid order's state and tickets must come from the server on every visit,
 * never from a restored copy that `refetchOnMount: false` would never correct.
 */
export const BOOKING_QUERY_ROOTS = {
    paidCart: 'paid-cart',
    paidCartConcessions: 'paid-cart-concessions',
    cartConcessions: 'cart-concessions',
    ticketsWithPasses: 'tickets-with-passes',
    groupTicketId: 'group-ticket-id',
    groupTicketGoogleWallet: 'group-ticket-google-wallet',
    seatLocks: 'seat-locks',
    priceOptions: 'price-options'
} as const;
